import * as React from 'react'

function SvgWhatsappIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.041 8.23c-4.241 0-7.689 3.447-7.69 7.687-.002 1.731.506 3.027 1.358 4.383l-.776 2.837 2.91-.764c1.304.774 2.548 1.238 4.193 1.239 4.237 0 7.69-3.45 7.69-7.688a7.686 7.686 0 00-7.685-7.695zm4.523 10.991c-.192.54-1.116 1.032-1.56 1.099-.399.06-.903.084-1.456-.092-.336-.107-.767-.25-1.317-.487-2.319-1.001-3.832-3.336-3.948-3.489-.116-.155-.944-1.253-.944-2.39 0-1.138.597-1.698.809-1.929a.85.85 0 01.616-.289l.443.008c.141.007.332-.053.52.397.192.463.654 1.6.712 1.716.057.116.096.251.018.406-.077.154-.116.25-.23.385l-.347.405c-.116.115-.236.24-.101.472.134.232.598.988 1.285 1.602.883.788 1.628 1.032 1.859 1.146.23.115.365.096.501-.057.135-.155.577-.675.732-.907.155-.23.308-.193.52-.116.212.078 1.348.636 1.579.752.23.116.385.174.442.27.06.096.06.558-.133 1.098zM16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm.039 25.173a9.259 9.259 0 01-4.424-1.125l-4.903 1.285 1.312-4.793a9.23 9.23 0 01-1.235-4.624c.002-5.1 4.151-9.25 9.25-9.25A9.188 9.188 0 0122.58 9.38a9.19 9.19 0 012.707 6.544c-.001 5.1-4.15 9.25-9.25 9.25z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgWhatsappIcon
